import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { IonSearchbar } from '@ionic/angular/standalone';
import { startOfDay } from 'date-fns/startOfDay';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { SiteArea } from 'src/app/models/site-area.model';
import { RoomTicket } from 'src/app/models/ticket.model';
import { TranslateTicketPipe } from 'src/app/pipes/ticket-translate/ticket-translate.pipe';
import { TimestampPipe } from 'src/app/pipes/timestamp/timestamp.pipe';
import { SelectDayComponent } from '../select-day/select-day.component';

export interface SelectedTicket extends RoomTicket {
  selected: boolean;
  roomName: string;
}

@Component({
  selector: 'app-select-tickets',
  templateUrl: './select-tickets.component.html',
  styleUrls: ['./select-tickets.component.scss'],
  imports: [
    AppCommonModule,
    CommonModule, TranslateTicketPipe,
    SelectDayComponent,
    TimestampPipe,
  ],
})
export class SelectTicketsComponent {

  private _selectedTickets: SelectedTicket[] = [];
  private filter$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  selectedArea = input<SiteArea>(null);
  tickets = input.required<SelectedTicket[]>();
  selectedTickets = output<SelectedTicket[]>();

  selectedStartDate$ = new BehaviorSubject<Date>(null);
  selectedEndDate$ = new BehaviorSubject<Date>(null);
  tickets$ = combineLatest([toObservable(this.tickets), this.selectedStartDate$.asObservable(), this.selectedEndDate$.asObservable(), this.filter$.asObservable()]).pipe(
    filter(([tickets]) => tickets != null),
    map(([tickets, startDate, endDate, text]) => tickets
      .filter((it) => this.selectedArea() == null || this.selectedArea().guid === it.area.guid)
      .filter((it) => startDate == null || it.date >= startDate)
      .filter((it) => endDate == null || it.date <= endDate)
      .filter((it) => it.name?.toLowerCase().includes(text.toLowerCase()) || it.guid?.toLowerCase().includes(text.toLowerCase())),
    ),
    shareReplay(1),
  );

  onFilter(inputElem: IonSearchbar) {
    const value = inputElem.value;
    this.filter$.next(value);
  }

  onDateChange(value: string, start: boolean) {
    if (value) {
      const date = startOfDay(new Date(value));
      if (start) {
        this.selectedStartDate$.next(date);
      } else {
        this.selectedEndDate$.next(date);
      }
    } else {
      if (start) {
        this.selectedStartDate$.next(null);
      } else {
        this.selectedEndDate$.next(null);
      }
    }
  }

  onSelectTicket(roomTicket: SelectedTicket) {
    roomTicket.selected = !roomTicket.selected;
    if (roomTicket.selected) {
      this._selectedTickets.push(roomTicket);
    } else {
      this._selectedTickets = this._selectedTickets.filter((it) => it.guid !== roomTicket.guid);
    }
    this.selectedTickets.emit(this._selectedTickets);
  }
}
